// removed by extract-text-webpack-plugin
module.exports = {"modal-content":"_2oKvXVLvL6mdZQC_HaP7bB","email-list":"_1tW2SQ1EzJ6Zjt-oFYCcX0","submit-button":"_1GDgChGJm2pCBoFndDviRh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/show/submissions/submissions.scss
// module id = 1671
// module chunks = 0